import ViewPadrao from "../views/ViewPadrao";
import UsuariosList from "../views/UsuariosList";
import UsuariosCad from "../views/UsuariosCad";
import PermissaoList from "../views/PermissaoList";
import PermissaoCad from "../views/PermissaoCad";

export default {
  path: "acesso",
  component: ViewPadrao,
  children: [
    {
      path: "usuarios",
      component: ViewPadrao,
      children: [
        {
          path: "",
          name: "usuarios-list",
          component: UsuariosList,
          meta: {
            auth: true,
            perms: ["auth.listar_usuarios"]
          }
        },
        {
          path: "novo",
          name: "usuarios-formulario",
          component: UsuariosCad,
          meta: {
            auth: true,
            perms: ["auth.criar_usuarios"]
          }
        },
        {
          path: "editar/:id",
          name: "usuarios-formulario-editar",
          component: UsuariosCad,
          meta: {
            auth: true,
            perms: ["auth.editar_usuarios"]
          }
        }
      ]
    },
    {
      path: "permissoes",
      component: ViewPadrao,
      children: [
        {
          path: "",
          name: "permissoes-list",
          component: PermissaoList,
          meta: {
            auth: true,
            perms: ["auth.listar_permissoes"]
          }
        },
        {
          path: "novo",
          name: "permissoes-formulario",
          component: PermissaoCad,
          meta: {
            auth: true,
            perms: ["auth.criar_permissoes"]
          }
        },
        {
          path: "editar/:id",
          name: "permissoes-formulario-editar",
          component: PermissaoCad,
          meta: {
            auth: true,
            perms: ["auth.editar_permissoes"]
          }
        }
      ]
    }
  ]
};
